import { store } from 'store'

export const execute = store.dispatch

export const dispatch = store.dispatch

export const getState = store.getState
